export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/question-mark.88093265.svg","height":24,"width":24};